import { DecimalPipe } from '@angular/common';
import { PipeTransform, Pipe } from '@angular/core';
import { TicketWinEvent } from 'src/app/model/ticket-win-event';

@Pipe({
    name: 'fullprize'
})
export class TicketWinEventFullPrizePipe implements PipeTransform
{
    private decimalPipe: DecimalPipe = new DecimalPipe('da-DK');
    
    public transform(event: TicketWinEvent): string 
    {
        const prize = event.Prize + event.PrizeTax;
        const multFact = this.getMultipliyingFactor(event.TicketInstance.Share.Type.Name);
        const result = prize * multFact;
        const mathRes = Math.trunc(Math.round(result / 100));
        return `${this.decimalPipe.transform(mathRes)} kr.`;
    }

    private getMultipliyingFactor(value: string): number
    {
        switch (value) {
            case "3/2": return 0.666666;
            case "Megalod": return 0.666666;
            case "3/2-lod": return 0.666666;
            case "1/1-lod": return 1;
            case "1/2-lod": return 2;
            case "1/4-lod": return 4;
            case "1/8-lod": return 8;

            default: throw new Error('? lod');
        }
    }
}
